import { styled } from '@mui/system'

export const Root = styled('a')`
	position: absolute;
	left: -9999px;
	background-color: var(--color-black);
	color: var(--color-white);
	padding: var(--spacing-1);
	overflow: hidden;
	opacity: 0;
	transition: all var(--transition);
	z-index: 1000;

	&:focus {
		left: 0;
		transform: translateX(0);
		opacity: 1;
	}
`
